import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Loader from "../Common/Loader";
import {
  createUnitOfDoseAction,
  updateUnitOfDoseAction,
} from "../../../store/actions/UnitOfDoseAction";

const AddUnitOfDose = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  // ✅ USE DIRECT FIELD NAMES
  const [unit_text, setUnitText] = useState("");
  const [unit_status, setUnitStatus] = useState("Active");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];


  useEffect(() => {
    if (item) {
      setUnitText(item.unit_text || "");
      setUnitStatus(item.unit_status || "Active");
    }
  }, [item]);

  const validateForm = () => {
    const err = {};
    if (!unit_text.trim()) err.unit_text = "Unit is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "unit_text") {
      setUnitText(value);
    } else if (field === "unit_status") {
      setUnitStatus(value);
    }
    clearFieldError(field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      unit_text,
      unit_status,
    };

    try {
      if (isEditMode) {
        await dispatch(
          updateUnitOfDoseAction({
            unit_id: item.id,
            ...payload,
          })
        );
      } else {
        await dispatch(createUnitOfDoseAction(payload));
      }

      navigate("/app-unit-of-dose");
    } catch (err) {
      console.error("Save failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end mb-3">
          <Link to="/app-unit-of-dose">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Unit */}
              <div className="mb-3">
                <label className="form-label">
                  Unit of Dose <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={unit_text}
                  style={{ padding: "0.375rem 0.75rem", paddingTop: "0.6rem" }}
                  onChange={(e) =>
                    handleFieldChange("unit_text", e.target.value)
                  }
                />
                {errors.unit_text && (
                  <small className="text-danger">{errors.unit_text}</small>
                )}
              </div>

              {/* Status */}
              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger">*</span>
                </label>

                <Select
                  options={statusOptions}
                  value={statusOptions.find(
                    (opt) => opt.value === unit_status
                  )}
                  onChange={(selectedOption) =>
                    setUnitStatus(selectedOption ? selectedOption.value : "")
                  }
                  placeholder="Select Status"
                  isClearable
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "50px",
                      height: "50px",
                      borderColor: errors.unit_status
                        ? "#dc3545"
                        : provided.borderColor,
                      boxShadow: errors.unit_status
                        ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                        : provided.boxShadow,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "50px",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "4px",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                />

                {errors.unit_status && (
                  <small className="text-danger">{errors.unit_status}</small>
                )}
              </div>


              <button className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">
                      {isEditMode ? "Updating..." : "Saving..."}
                    </span>
                  </>
                ) : isEditMode ? (
                  "Update Unit"
                ) : (
                  "Add Unit"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUnitOfDose;
